import { Link, useNavigate } from "react-router-dom";

export default function VehicleFineTable() {
  const navigate = useNavigate();

  const handleNavigate = (vehiclename) => {
    navigate(`/${vehiclename}`);
  };

  const data = [
    { id: 1, vehiclename: "New Vehicle", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 2, vehiclename: "Test Vehicle", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Paid", amount: "$1000" },
    { id: 3, vehiclename: "Test Vehicle", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Paid", amount: "$1000" },
    { id: 4, vehiclename: "MH04KL0921", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 5, vehiclename: "MH05MH5932", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 6, vehiclename: "MH06MJ4321", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 7, vehiclename: "Test Vehicle", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 8, vehiclename: "MH08KK4909", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 9, vehiclename: "MH11KL0008", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 10, vehiclename: "MH20UI3424", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 11, vehiclename: "Test Vehicle", driver: "Test Driver", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 12, vehiclename: "MH23MK8245", driver: "Test Driver", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 13, vehiclename: "MH24NF5321", driver: "Jake Sprrow", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 14, vehiclename: "MH22PQ4441", driver: "Tom tricky", reason: "Seat Belt", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 15, vehiclename: "New Vehicle", driver: "John wick", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 16, vehiclename: "MH11FG9090", driver: "John wick", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 17, vehiclename: "MH20UI1221", driver: "Tom Salt", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 18, vehiclename: "Mh20JJ9430", driver: "Snow Wick", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Paid", amount: "$7650" },
    { id: 19, vehiclename: "MH20SQ0987", driver: "Harry Davison", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
    { id: 20, vehiclename: "New Vehicle", driver: "Jerrey Cook", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
  ];

  const statusVariant = (s) => {
    const v = (s || "").toLowerCase();
    if (v === "paid") return "yc-status--success";
    if (v === "active") return "yc-status--info";
    return "yc-status--neutral";
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Fine</h4>
        <div className="yc-header-actions">
          <Link to="/accountant/createvehiclefine" className="btn btn-primary">
            Create Vehicle Fine
          </Link>
          <div className="dropdown">
            <button
              id="btnGroupDropExport"
              type="button"
              className="btn btn-primary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
              <li><a className="dropdown-item" href="#">Save as PDF</a></li>
              <li><a className="dropdown-item" href="#">Save as CSV</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select className="form-select">
            <option>All</option>
            <option>MH20EE3948</option>
            <option>Test Vehicle</option>
          </select>
          <input type="text" className="form-control" placeholder="Reason" />
          <button type="button" className="btn btn-primary">Clear</button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-8">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Vehicle Name</div>
            <div className="yc-list-cell">Driver</div>
            <div className="yc-list-cell">Reason</div>
            <div className="yc-list-cell">Date</div>
            <div className="yc-list-cell">Status</div>
            <div className="yc-list-cell">Amount</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {data.map((row, idx) => (
            <div key={row.id} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-8">
                <div className="yc-list-cell">{idx + 1}</div>
                <div className="yc-list-cell">{row.vehiclename}</div>
                <div className="yc-list-cell">{row.driver}</div>
                <div className="yc-list-cell">{row.reason}</div>
                <div className="yc-list-cell">{row.date}</div>
                <div className="yc-list-cell">
                  <span className={`yc-status ${statusVariant(row.status)}`}>{row.status}</span>
                </div>
                <div className="yc-list-cell">{row.amount}</div>
                <div className="yc-list-cell yc-list-cell--actions">
                  <button
                    type="button"
                    className="yc-action-icon"
                    onClick={() => handleNavigate(row.vehiclename)}
                    title="View"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <Link to="/updatevehiclefine" className="yc-action-icon" title="Edit">
                    <i className="bi bi-pencil-square"></i>
                  </Link>
                  <button
                    type="button"
                    className="yc-action-icon yc-action-icon--danger"
                    onClick={() => handleNavigate(row.vehiclename)}
                    title="Delete"
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
